import C19_PromotionalArticles, {
  ArticlePromotionType,
} from "@components/C19_PromotionalArticles/C19_PromotionalArticles";
import { fetchApi } from "@utilities/fetchApi";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

export interface PromotionalArticlesBSRProps {
  isBlue: boolean;
  tags?: string[];
  selectedAuthor?: any;
  numberOfItems?: number;
  bsrArticles?: any;
}

const PromotionalArticlesBSR = ({
  content,
}: {
  content: PromotionalArticlesBSRProps;
}) => {
  const { bsrArticles, isBlue, selectedAuthor, numberOfItems, tags } = content;
  const [articles, setArticles] = useState<ArticlePromotionType[]>([]);
  const { asPath } = useRouter();
  const tagIds = tags || [];

  useEffect(() => {
    const getData = async () => {
      const omitSlug = asPath.split("#")[0].split("?")[0].slice(1);
      const articles = (
        await Promise.all([
          tagIds.length
            ? fetchApi("/api/getBSRArticlesByTags", {
                tagIDs: tagIds.join(","),
                limit: numberOfItems?.toString(),
                omitSlug,
              })
            : [],
          selectedAuthor?.fields?.articleAuthorName
            ? fetchApi("/api/getBSRArticlesByAuthor", {
                selectedAuthor: selectedAuthor?.fields?.articleAuthorName,
                limit: numberOfItems?.toString(),
                omitSlug,
              })
            : [],
        ])
      ).flat();
      setArticles(articles);
    };

    if (bsrArticles) {
      setArticles(
        bsrArticles?.map((article) => ({
          title: article.fields.articleTitle,
          description: article.fields.shortDescription,
          image: article.fields.articleThumbnail || null,
          authors:
            article.fields.authorsList?.map(
              ({ fields: { articleAuthorName } }) => articleAuthorName
            ) || null,
          slug: article.fields.slug,
        }))
      );
    } else if ((tagIds.length || selectedAuthor) && numberOfItems) {
      getData();
    }
  }, []);

  return (
    <C19_PromotionalArticles
      articles={articles?.map((article) => ({
        ...article,
        subtitle: "Think at London Business School",
      }))}
      isBlue={isBlue}
      ctaText="Find out more"
    />
  );
};

export default PromotionalArticlesBSR;
